<div class="ms-4 me-4"></div>

<mat-stepper [linear]="true" #stepper>

    <mat-step [stepControl]="formStepUno">

        <form [formGroup]="formStepUno">

            <ng-template matStepLabel>Struttura</ng-template>

            <div class="mt-2 mb-2">

                <mat-card appearance="outlined">



                    <mat-card-content>

                        <div class="row" *ngIf="!uvmPresente">
                            <div class="col">


                                <mat-form-field>
                                    <mat-label>Tipo struttura</mat-label>
                                    <mat-select disabled [value]="8">
                                        <mat-option [value]="8" selected>{{tipoStrutturaSanDescr}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                            </div>
                        </div>

                        <div class="mt-3"></div>

                        <mat-form-field>

                            <mat-label>Cerca...</mat-label>
                            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>

                        </mat-form-field>


                        <div class="mat-elevation-z8">
                            <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>

                                <!-- ID Column -->
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.id }} </td>
                                </ng-container>


                                <!-- Disrretto Column -->
                                <ng-container matColumnDef="distretto">
                                    <th mat-header-cell *matHeaderCellDef> Distretto </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.progDistretto?.descrizione }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="tipoStruttura">
                                    <th mat-header-cell *matHeaderCellDef> Tipo Str. </th>
                                    <td mat-cell *matCellDef="let element"> {{
                                        element.codTipologiaStruttura?.descrizione }} </td>
                                </ng-container>

                                <!-- Codice Column -->
                                <ng-container matColumnDef="codice">
                                    <th mat-header-cell *matHeaderCellDef> Codice </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.codice }} </td>
                                </ng-container>

                                <!-- Descrizione Column -->
                                <ng-container matColumnDef="descrizione">
                                    <th mat-header-cell *matHeaderCellDef> Descrizione </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.denominazione }} </td>
                                </ng-container>

                                <ng-container matColumnDef="tipologiaGiuridica">
                                    <th mat-header-cell *matHeaderCellDef> T. Giuridica </th>
                                    <td mat-cell *matCellDef="let element"> {{
                                        element.codTipologiaGiuridica?.descrizione }} </td>
                                </ng-container>

                                <ng-container matColumnDef="codNazionaleAsl">
                                    <th mat-header-cell *matHeaderCellDef> Codice Naz. ASL </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.codNazionaleAsl }} </td>
                                </ng-container>

                                <ng-container matColumnDef="tipoResidenza">
                                    <th mat-header-cell *matHeaderCellDef> Tipo residenza </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.codTipoResidenza?.descrizione }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="tipoAssistenza">
                                    <th mat-header-cell *matHeaderCellDef> Tipo assistenza </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.codTipoAssistenza?.descrizione }}
                                    </td>
                                </ng-container>


                                <ng-container matColumnDef="secondary">
                                    <td mat-cell [attr.colspan]="displayedColumns.length" *matCellDef="let element">


                                        <div class="mt-2"></div>
                                        <div *ngFor="let item of element.strutture">

                                            <div class="row">
                                                <div class="col">
                                                    <hr>
                                                    <strong>ID:</strong>{{item.id}}<br>
                                                    <strong>Distretto:</strong>{{item.progDistretto?.descrizione }}<br>
                                                    <strong>Tipo Str.:</strong>{{item.codTipologiaStruttura?.descrizione
                                                    }}<br>
                                                    <strong>Codice:</strong>{{item.codice}}<br>
                                                    <strong>Descrizione:</strong>{{item.denominazione}}<br>
                                                    <strong>T.
                                                        Giuridica:</strong>{{item.codTipologiaGiuridica?.descrizione
                                                    }}<br>
                                                    <strong>Codice Naz. ASL:</strong>{{item.codNazionaleAsl}}<br>
                                                    <strong>Tipo residenza</strong>{{item.codTipoResidenza?.descrizione
                                                    }}<br>
                                                    <strong>Tipo
                                                        assistenza:</strong>{{item.codTipoAssistenza?.descrizione }}<br>
                                                    <button mat-flat-button class="mt-4" (click)="onStepSubmit(item)">Seleziona</button>

                                                    <hr>
                                                </div>
                                            </div>


                                        </div>
                                    </td>
                                </ng-container>



                                <!-- Header and Row Definitions -->
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['secondary'];"></tr>
                            </table>
                        </div>

                        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                            aria-label="Select page of periodic elements">
                        </mat-paginator>

                    </mat-card-content>


                </mat-card>
            </div>

        </form>
    </mat-step>



    <mat-step [stepControl]="formStepDue">
        <form [formGroup]="formStepDue">

            <ng-template matStepLabel>Ulteriori dati inserimento</ng-template>

            <div class="mt-2 mb-2">
                <mat-card appearance="outlined">

                    <mat-card-content>

                        <mat-card appearance="outlined">

                            <mat-card-content>

                                <div class="row">
                                    <div class="mt-2"></div>
                                </div>

                                <div class="row">
                                    <div class="col">

                                        <b>Struttura</b>

                                        <div class="mt-2" *ngIf="strutturaSelezionata">
                                            <span *ngIf="strutturaSelezionata.parentDetails"><strong>Struttura padre:</strong> {{strutturaSelezionata.parentDetails.oid_2}} - {{strutturaSelezionata.parentDetails.codice}} - {{strutturaSelezionata.parentDetails.descrizione}}<br></span>
                                            <strong>ID:</strong> {{strutturaSelezionata.id}}<br>
                                            <strong>Distretto:</strong>
                                            {{strutturaSelezionata.progDistretto?.descrizione}}<br>
                                            <strong>Tipo Str.:</strong>
                                            {{strutturaSelezionata.codTipologiaStruttura?.descrizione}}<br>
                                            <strong>Codice:</strong> {{strutturaSelezionata.codice}}<br>
                                            <strong>Descrizione:</strong> {{strutturaSelezionata.denominazione}}<br>
                                            <strong>T.Giuridica:</strong>
                                            {{strutturaSelezionata.codTipologiaGiuridica?.descrizione}}<br>
                                            <strong>Codice Naz. ASL:</strong>
                                            {{strutturaSelezionata.codNazionaleAsl}}<br>
                                            <strong>Tipo residenza</strong>
                                            {{strutturaSelezionata.codTipoResidenza?.descrizione}}<br>
                                            <strong>Tipo assistenza:</strong>
                                            {{strutturaSelezionata.codTipoAssistenza?.descrizione}}<br>

                                        </div>
                                    </div>
                                </div>





                            </mat-card-content>

                        </mat-card>

                        <div class="row d-flex mt-4">

                            <div class="col">
                                <mat-form-field>
                                    <mat-label>Inizio</mat-label>
                                    <input matInput [matDatepicker]="picker" formControlName="dataInizioIntervento">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="col">
                                <mat-form-field>
                                    <mat-label>Fine</mat-label>
                                    <input matInput [matDatepicker]="picker2" formControlName="dataFineIntervento">
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col">
                                <mat-form-field>
                                    <mat-label>Note</mat-label>
                                    <textarea matInput formControlName="note"></textarea>
                                </mat-form-field>
                            </div>
                        </div>

                    </mat-card-content>

                    <mat-card-actions>
                        <button mat-flat-button matStepperNext>Continua</button>
                    </mat-card-actions>

                </mat-card>
            </div>

        </form>
    </mat-step>



    <mat-step [stepControl]="formStepTre">
        <form [formGroup]="formStepTre">

            <ng-template matStepLabel>Riepilogo</ng-template>

            <div class="mt-2 mb-2">
                <mat-card appearance="outlined">

                    <mat-card-content>

                        <mat-card appearance="outlined">

                            <mat-card-content>

                                <div class="row">
                                    <div class="mt-2"></div>
                                </div>

                                <div class="row">
                                    <div class="col">

                                        <b>Struttura</b>

                                        <div class="mt-2" *ngIf="strutturaSelezionata">

                                            <strong>ID:</strong> {{strutturaSelezionata.id}}<br>
                                            <strong>Distretto:</strong>
                                            {{strutturaSelezionata.progDistretto?.descrizione}}<br>
                                            <strong>Tipo Str.:</strong>
                                            {{strutturaSelezionata.codTipologiaStruttura?.descrizione}}<br>
                                            <strong>Codice:</strong> {{strutturaSelezionata.codice}}<br>
                                            <strong>Descrizione:</strong> {{strutturaSelezionata.denominazione}}<br>
                                            <strong>T.Giuridica:</strong>
                                            {{strutturaSelezionata.codTipologiaGiuridica?.descrizione}}<br>
                                            <strong>Codice Naz. ASL:</strong>
                                            {{strutturaSelezionata.codNazionaleAsl}}<br>
                                            <strong>Tipo residenza</strong>
                                            {{strutturaSelezionata.codTipoResidenza?.descrizione}}<br>
                                            <strong>Tipo assistenza:</strong>
                                            {{strutturaSelezionata.codTipoAssistenza?.descrizione}}<br>

                                        </div>
                                    </div>
                                </div>





                            </mat-card-content>

                        </mat-card>


                        <div class="mt-2"></div>

                        <mat-card appearance="outlined">

                            <mat-card-content>




                                <div class="col">

                                    <b>Ulteriori dati inserimento</b>

                                    <div class="mt-2" *ngIf="strutturaSelezionata">

                                        <strong>Inizio:</strong> {{
                                        formStepDue.get('dataInizioIntervento')?.value |
                                        date:'dd/MM/yyyy' }}<br>
                                        <strong>Fine:</strong> {{
                                        formStepDue.get('dataFineIntervento')?.value |
                                        date:'dd/MM/yyyy' }}<br>
                                        <strong>Note:</strong> {{ formStepDue.get('note')?.value }}<br>
                                    </div>
                                </div>
                            </mat-card-content>



                        </mat-card>

                        <div class="mt-2"></div>

                    </mat-card-content>

                    <mat-card-actions>

                        <div class="d-flex m-2">

                            <div style="margin-right: 0.5rem;">
                                <button (click)="conferma()" mat-flat-button>Conferma e continua</button>
                            </div>

                            <div style="margin-right: 0.5rem;">
                                <button (click)="pulisci(stepper)" mat-button>
                                    <mat-icon>cleaning_services</mat-icon>Revisiona
                                </button>
                            </div>

                        </div>

                    </mat-card-actions>

                </mat-card>
            </div>

        </form>
    </mat-step>


</mat-stepper>